import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$survey_card",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  container: {
    alignItems: "center",
  },
  image: {
    height: 300,
    width: 300,
  },
});
